import React from "react";
import "../Contact.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { motion } from "framer-motion";

import {

    FaEnvelope,
    FaPhoneAlt,
    FaMapMarkerAlt,
    FaClock,
    FaShieldAlt,
    FaCheckCircle

} from "react-icons/fa";



const Contact = () => {


    return (

        <>

            <Header />


            <title>
                Contact BlueLotus Infrasafety Projects Private Limited | Cybersecurity Experts
            </title>



            {/* HERO */}


            <section className="contact-hero">


                <div className="container">


                    <motion.div

                        className="contact-hero-content"

                        initial={{ opacity: 0, y: 40 }}

                        animate={{ opacity: 1, y: 0 }}

                        transition={{ duration: .8 }}

                    >


                        <span>

                            Secure Your Digital Future

                        </span>


                        <h1>

                            Let's Build A Stronger
                            <h1 style={{ display: "block", color: "#60a5fa" }}>Cybersecurity Defense</h1>

                        </h1>


                        <p>

                            Connect with BlueLotus Infrasafety Projects Private Limited cybersecurity specialists
                            for security assessments, threat protection,
                            and enterprise security solutions.

                        </p>


                    </motion.div>


                </div>


            </section>








            {/* CONTACT SECTION */}


            <section className="contact-section">


                <div className="container contact-grid">





                    {/* INFORMATION */}


                    <div className="contact-info">


                        <h2>

                            Contact BlueLotus

                        </h2>


                        <p>

                            Our cybersecurity experts are ready to understand
                            your security challenges and provide the right
                            protection strategy for your organization.

                        </p>





                        <div className="contact-box">


                            <div className="contact-icon">

                                <FaEnvelope />

                            </div>


                            <div style={{textAlign:"left"}}>

                                <h4>Email</h4>

                                <p style={{color:"blue", marginTop:"15px", fontSize:"14px"}}>
                                    <a href="mailto:sites@bluelotusprojects.in">
                                        sites@bluelotusprojects.in
                                    </a>

                                </p>

                            </div>


                        </div>






                        <div className="contact-box">


                            <div className="contact-icon">

                                <FaPhoneAlt />

                            </div>


                            <div style={{textAlign:"left"}}>

                                <h4>Phone</h4>

                                <p style={{color:"blue", marginTop:"15px", fontSize:"14px"}}>
                                    <a href="tel:+916822892309">
                                        06822892309
                                    </a>

                                </p>

                            </div>


                        </div>






                        <div className="contact-box">


                            <div className="contact-icon">

                                <FaMapMarkerAlt />

                            </div>


                            <div style={{textAlign:"left"}}>

                                <h3>Register Office Address</h3>

                                <a
                                    href="https://maps.google.com/?q=No1 Mukteshwar Apartment H16 Near Pachimeswar Temple Ankuli Brahmapur Ganjam Odisha 760010"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="contact-item"
                                >


                                    <p style={{color:"blue", marginTop:"15px", fontSize:"14px"}}>
                                        No.1, Mukteshwar Apartment, H16,
                                        <br />Near Pachimeswar Temple
                                        
                                        Ankuli, Brahmapur Sadar,
                                        Ganjam, Odisha, India - 760010
                                    </p>

                                </a>

                            </div>


                        </div>






                        <div className="contact-box">


                            <div className="contact-icon">

                                <FaClock />

                            </div>


                            <div style={{textAlign:"left"}}>

                                <h4>Working Hours</h4>

                                <p style={{color:"blue", marginTop:"15px", fontSize:"14px"}}>
                                    Monday - Friday
                                    9:00 AM - 6:00 PM
                                </p>

                            </div>


                        </div>



                    </div>









                    {/* FORM */}


                    <div className="contact-form">


                        <h2>

                            Request Security Consultation

                        </h2>


                        <p>

                            Tell us about your security requirements.

                        </p>



                        <form>


                            <div className="form-grid">


                                <input
                                    type="text"
                                    placeholder="Your Name"
                                />


                                <input
                                    type="email"
                                    placeholder="Email Address"
                                />


                                <input
                                    type="text"
                                    placeholder="Company Name"
                                />


                                <input
                                    type="tel"
                                    placeholder="Phone Number"
                                />


                            </div>



                            {/* <select>

                                <option>
                                    Select Service
                                </option>

                                <option>
                                    Network Security
                                </option>

                                <option>
                                    Cloud Security
                                </option>

                                <option>
                                    Penetration Testing
                                </option>

                                <option>
                                    Security Monitoring
                                </option>

                                <option>
                                    Incident Response
                                </option>

                            </select> */}




                            <textarea

                                rows="5"

                                placeholder="Your Message"

                            >



                            </textarea>



                            <button>

                                Submit Request

                            </button>


                        </form>


                    </div>





                </div>


            </section>










            {/* WHY CONTACT */}


            <section className="contact-benefits">


                <div className="container">


                    <h2>

                        Why Work With BlueLotus?

                    </h2>



                    <div className="benefit-grid">



                        <div>

                            <FaShieldAlt />

                            <h3>

                                Expert Security Team

                            </h3>

                            <p>

                                Experienced cybersecurity professionals
                                protecting your business.

                            </p>

                        </div>





                        <div>

                            <FaCheckCircle />

                            <h3>

                                Proactive Protection

                            </h3>

                            <p>

                                Identify and prevent threats before
                                they impact operations.

                            </p>

                        </div>





                        <div>

                            <FaClock />

                            <h3>

                                Fast Response

                            </h3>

                            <p>

                                Quick support during security incidents
                                and critical situations.

                            </p>

                        </div>



                    </div>


                </div>


            </section>








            {/* CTA */}


            {/* <section className="contact-cta">


                <div className="container">


                    <h2>

                        Ready To Secure Your Business?

                    </h2>


                    <p>

                        Schedule a cybersecurity consultation
                        with BlueLotus experts today.

                    </p>


                </div>


            </section> */}






            <Footer />


        </>

    )

}


export default Contact;